import styled from 'styled-components/macro';

import { InputIcon, InputWrapperDiv } from '../Wrapper/Wrapper.styled';

export const Counter = styled(InputWrapperDiv)<{ error?: boolean; $inputIconRounded?: boolean }>`
  user-select: none;

  & > input {
    font-size: ${({ $inputIconRounded, theme }) =>
      $inputIconRounded ? theme.fontSize.md : theme.fontSize.xs};
    font-family: ${({ theme }) => theme.fontFamily.semiBold};
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
    text-align: center;
    color: ${({ $inputIconRounded, theme }) => $inputIconRounded && theme.colors.black_100};
  }

  & > ${InputIcon} {
    :hover {
      cursor: pointer;
    }
  }

  ${({ error, theme }) => error && `border: 1px solid ${theme.colors.negative_dark}`};
`;
